var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"f f-y-start f-wrap space-x-0.5 space-y-0.5"},_vm._l((_vm.data),function(item){return _c('div',{key:item[_vm.valueKey],on:{"click":function($event){return _vm.click(item)}}},[_vm._t("default",null,null,_vm.scope(item))],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }